<div class="row mb-2" *ngIf="!global.employeetoAgreementEmit">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent  text-muted">
                <div class="row col-12" *ngIf="Employee.id=='00000000-0000-0000-0000-000000000000'">
                    <div class="col-8">
                        <h4 class="mb-0 font-header">New Employee</h4>
                    </div>
                    <!-- <div class="row mt-3" *ngIf="Employee.id=='00000000-0000-0000-0000-000000000000'"> -->

                    <div class="col-2" *ngIf="Employee.id=='00000000-0000-0000-0000-000000000000'">
                        <!-- [disabled]="saveEmployeeInProgress || EmployeeDataForm.invalid ||(Employee.requiredEVV && (Employee.username==null || Employee.username==undefined || Employee.username==''|| Employee.password==undefined ||Employee.password==null || Employee.password=='' || passerror))" -->
                        <div class="d-flex  text-right text-end ">
                            <button class="btn btn-sm ms-1  text-right text-end " type="button" [disabled]="
                            (Employee.driverLicense != null && Employee.driverLicense != undefined && Employee.driverLicense != ''&& (Employee.driverLicenseExpirydate == null || Employee.driverLicenseExpirydate == undefined || Employee.driverLicenseExpirydate == '') ) ||
                            saveEmployeeInProgress
                                 ||Employee.firstName==null||Employee.firstName==undefined||Employee.firstName==''
                                 ||Employee.genderLid==null||Employee.genderLid==undefined||Employee.genderLid==''||
                                 Employee.lastName==null||Employee.lastName==undefined||Employee.lastName==''
                                 ||Employee.dOB==null||Employee.dOB==undefined||Employee.dOB==''||
                                
                                 Employee.email==null||Employee.email==undefined||Employee.email==''||
                                 EmployeeDataForm.controls['uMPI'].invalid || EmployeeDataForm.controls['rNNPI'].invalid ||
                                 EmployeeDataForm.controls['email'].touched && EmployeeDataForm.controls['email'].invalid ||
                                (Employee.requiredEVV && (Employee.username==null || Employee.username==undefined ||
                                 Employee.username==''|| 
                                  Employee.password==undefined ||Employee.password==null || 
                                 Employee.password=='' || passerror))" (click)="SaveorUpdateEmployee(Employee)"
                                tabindex="27">Save</button>
                            <button type="button" class="btn btn-sm ms-1  text-right text-end "
                                (click)="backToEmployeeList()" tabindex="28">Close</button>
                        </div>
                    </div>
                    <!-- </div> -->




                    <div class="col-2">
                        <label class="notealert">Note: * fields are mandatory</label>
                    </div>
                </div>
                <!-- <div class="row mt-3" *ngIf="Employee.id=='00000000-0000-0000-0000-000000000000'">
                    <div class="col-lg-8">

                    </div>
                    <div class="col-lg-2"> -->
                <!-- [disabled]="saveEmployeeInProgress || EmployeeDataForm.invalid ||(Employee.requiredEVV && (Employee.username==null || Employee.username==undefined || Employee.username==''|| Employee.password==undefined ||Employee.password==null || Employee.password=='' || passerror))" -->
                <!-- <div class="d-flex  text-right text-end "> 
                            <button class="btn btn-sm ms-1  text-right text-end " type="button" [disabled]="saveEmployeeInProgress
                             ||Employee.firstName==null||Employee.firstName==undefined||Employee.firstName==''
                             ||Employee.genderLid==null||Employee.genderLid==undefined||Employee.genderLid==''||
                             Employee.lastName==null||Employee.lastName==undefined||Employee.lastName==''
                             ||Employee.dOB==null||Employee.dOB==undefined||Employee.dOB==''||
                            
                             Employee.email==null||Employee.email==undefined||Employee.email==''||

                            (Employee.requiredEVV && (Employee.username==null || Employee.username==undefined ||
                             Employee.username==''|| 
                              Employee.password==undefined ||Employee.password==null || 
                             Employee.password=='' || passerror))" (click)="SaveorUpdateEmployee(Employee)"
                                tabindex="27">Save</button>
                            <button type="button" class="btn btn-sm ms-1  text-right text-end " (click)="backToEmployeeList()"
                                tabindex="28">Close</button>
                         </div>
                    </div>
                </div> -->
                <div class="row col-12" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'">

                    <div class="col-8">
                        <h4 class="mb-0 font-header">Update Employee</h4>
                    </div>

                    <!-- ........................................................ -->

                    <!-- <div class="row" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'"> -->

                    <div class="col-2" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'">
                        <button type="button" class="btn btn-sm ms-1 " *ngIf="isEditDisable" tabindex="28"
                            (click)="editFunctionButton()">Edit</button>
                        <button class="btn  btn-sm ms-1 " *ngIf="isShowFields" type="button" [disabled]=" 
                      
                        (Employee.driverLicense != null && Employee.driverLicense != undefined && Employee.driverLicense != ''&& (Employee.driverLicenseExpirydate == null || Employee.driverLicenseExpirydate == undefined || Employee.driverLicenseExpirydate == '') ) ||
                        saveEmployeeInProgress
                            ||Employee.firstName==null||Employee.firstName==undefined||Employee.firstName==''
                            ||Employee.genderLid==null||Employee.genderLid==undefined||Employee.genderLid==''||
                            Employee.lastName==null||Employee.lastName==undefined||Employee.lastName==''
                            ||Employee.dOB==null||Employee.dOB==undefined||Employee.dOB==''||
                           
                            Employee.email==null||Employee.email==undefined||Employee.email==''||
                            EmployeeDataForm.controls['uMPI'].invalid || EmployeeDataForm.controls['rNNPI'].invalid ||
                            EmployeeDataForm.controls['email'].touched && EmployeeDataForm.controls['email'].invalid ||
                            (Employee.loginUserId!=null && (Employee.requiredEVV && (Employee.username==null||Employee.username==undefined||
                                        Employee.username==''))) ||
                                         (Employee.loginUserId==null&& (Employee.requiredEVV&& (Employee.username==null||Employee.username==undefined ||
                                        Employee.username==''|| Employee.password==undefined || Employee.password==null ||
                                        Employee.password=='' || passerror) ))"
                            (click)="SaveorUpdateEmployee(Employee)" tabindex="27">Update </button>

                        <button type="button" class="btn  btn-sm ms-1 " (click)="backToEmployeeList()"
                            tabindex="28">Close</button>
                    </div>
                    <!-- </div> -->

                    <div class="col-2">
                        <label class="notealert">Note: * fields are mandatory</label>
                    </div>
                </div>
            </div>
            <!--.................................1 rowwwww............................  -->

            <div class="card-body  pb-0 pt-2  mb-4">
                <div class="row">
                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class="label-bold ">Status</label>&nbsp;
                            </div>
                            <div class="col-lg-8">
                                <ng-select class="w-100" [(ngModel)]="Employee.statusLid" [searchable]="true"
                                    [clearable]="true" (change)="EmployeeChange()" [items]="EmployeestatusList"
                                    bindLabel="lovName" [disabled]="global.viewTabs" bindValue="id">
                                </ng-select>


                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-3">
                                <label class="label-bold">Employee</label>&nbsp;
                            </div>
                            <div class="col-lg-6 pt-2 ms-5">
                                <label data-toggle="modal" data-target="#showPopup" placement="right">
                                    {{EmployeeDataForm.value.lastName}}&nbsp;{{EmployeeDataForm.value.firstName}}&nbsp;{{EmployeeDataForm.value.middleName}}</label>

                            </div>
                        </div>
                    </div>


                    <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2 me-2 ">
                                <label class=" label-bold ">DOB</label> &nbsp;
                            </div>
                            <div class="col-lg-4 me-1 pt-2">
                                <label class=" me-1">{{Employee.dOB}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class=" me-1 label-bold">Age</label> &nbsp;
                            </div>
                            <div class="col-lg-4 pt-2">
                                <label>{{Employee.age}}</label>
                            </div>
                        </div>
                    </div>



                </div>


                <!-- .............................2rrrrrr....................... -->

                <div class="row">
                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class="label-bold ">Location</label>&nbsp;
                            </div>
                            <div class="col-lg-8">
                                <ng-select class="w-100 col-lg-5" [(ngModel)]="Employee.locationId"
                                    name="locationStatus" [searchable]="true" [clearable]="true"
                                    (change)="EmployeeChange()" [items]="getLocationList" bindLabel="Value"
                                    [disabled]="global.viewTabs" bindValue="Key">
                                </ng-select>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class="label-bold ">Mail</label> &nbsp;
                            </div>
                            <div class="col-lg-6 pt-2">
                                <label>{{Employee.email}}</label>
                            </div>
                        </div>
                    </div>




                    <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class=" me-1 label-bold">UMPI</label> &nbsp;
                            </div>
                            <div class="col-lg-4 pt-2">
                                <label>{{Employee.uMPI}}</label>
                            </div>
                        </div>
                    </div>



                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-4">
                                <label class=" me-1 label-bold">User Name</label> &nbsp;
                            </div>
                            <div class="col-lg-4 pt-2">
                                <label>{{Employee.username}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-5 me-2 ">
                                <label class="label-bold ">Employee Type</label> &nbsp;
                            </div>


                            <div class="col-lg-6">
                                <ng-select class="w-100" [searchable]="true" [(ngModel)]="Employee.employeeTypeLid"
                                    [clearable]="true" [items]="EmployeeTypeItems" bindLabel="lovName" bindValue="id"
                                    disabled>
                                </ng-select>
                            </div>

                        </div>
                    </div>


                </div>
            </div>




            <!-- <div class="row mt-3" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'">
                    <div class="col-lg-7">

                    </div>
                    <div class="col-lg-3 text-end">
                        <button type="button" class="btn btn-sm ms-1 " *ngIf="isEditDisable" tabindex="28"
                            (click)="editFunctionButton()">Edit</button>
                        <button class="btn  btn-sm ms-1 " *ngIf="isShowFields" type="button" 
                        [disabled]=" saveEmployeeInProgress
                        ||Employee.firstName==null||Employee.firstName==undefined||Employee.firstName==''
                        ||Employee.genderLid==null||Employee.genderLid==undefined||Employee.genderLid==''||
                        Employee.lastName==null||Employee.lastName==undefined||Employee.lastName==''
                        ||Employee.dOB==null||Employee.dOB==undefined||Employee.dOB==''||
                       
                        Employee.email==null||Employee.email==undefined||Employee.email==''||

                        (Employee.loginUserId!=null && (Employee.requiredEVV && (Employee.username==null||Employee.username==undefined||
                                    Employee.username==''))) || (Employee.loginUserId==null&& (Employee.requiredEVV&& (Employee.username==null||Employee.username==undefined ||
                                    Employee.username==''|| Employee.password==undefined || Employee.password==null ||
                                    Employee.password=='' || passerror) ))" (click)="SaveorUpdateEmployee(Employee)"
                            tabindex="27">Update </button>

                        <button type="button" class="btn  btn-sm ms-1 " (click)="backToEmployeeList()"
                            tabindex="28">Close</button>
                    </div>
                </div> -->

            <!-- <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row">
                    <div class="col-lg-4 col-md-3 col-xs-4" style="border-right:3px solid  grey">
                        <div class="row mt-1">
                            <div class="col-lg-5 col-md-4 col-xs-4 ">

                                <label data-bs-toggle="modal" data-bs-target="#showPopup" placement="right"
                                    style="width: 178px;"
                                    class="me-1 label-bold ">{{EmployeeDataForm.value.lastName}}&nbsp;{{EmployeeDataForm.value.firstName}}&nbsp;{{EmployeeDataForm.value.middleName}}</label>
                            </div>
                            <!-- Status Dropdown -->
            <!-- <div class="col-lg-3 col-md-4 col-xs-4" [formGroup]="EmployeeDataForm">
                                <select class="form-control" [(ngModel)]="Employee.statusLid"
                                    formControlName="statusLid" (change)="EmployeeChange()">
                                    <option [value]="i.id" *ngFor="let i of EmployeestatusList">{{i.lovName}}
                                    </option>
                                </select>
                            </div> -->
            <!-- Location Dropdown -->
            <!-- <div class="col-lg-4  col-md-4 col-xs-4 " [formGroup]="EmployeeDataForm">
                                <select class="form-control" [(ngModel)]="Employee.locationId"
                                    formControlName="locationId" name="locationStatus" (change)="EmployeeChange()">
                                    <option [value]=loc.Key *ngFor="let loc of getLocationList">{{loc.Value}}</option>
                                </select>
                            </div>
                        </div> -->
            <!-- <div class="row mt-1 ms-0"> -->
            <!-- Employee dOB -->
            <!-- <div class="col-lg-2 col-md-5 col-xs-5 buttonpaddinglr">
                                <label class="font-weight-bold">DOB:
                                </label>
                            </div>
                            <div class="col-lg-6 col-md-7 col-xs-7 buttonpaddinglr">
                                <label>{{Employee.dOB}}</label>
                            </div>
                        </div> -->
            <!-- <div class="row mt-1 ms-0"> -->
            <!-- Employee Type Dropdown -->
            <!-- <div class="col-lg-5 col-md-5 col-xs-5 buttonpaddinglr">
                                <label class="font-weight-bold">Employee Type
                                </label>
                            </div>
                            <div class="col-lg-5 col-md-7 col-xs-7 buttonpaddinglr" [formGroup]="EmployeeDataForm">
                                <ng-select class="w-100" formControlName="employeeTypeLids" [searchable]="true"
                                    [(ngModel)]="Employee.employeeTypeLid" [clearable]="true"
                                    [items]="EmployeeTypeItems" bindLabel="lovName" bindValue="id"
                                    (change)="EmployeeChange()">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-3 col-xs-4" style="border-right:3px solid  grey">
                        <div class="row ms-1  me-1" style="border-bottom:1px solid grey">
                            <label class="headerInfo-label">Supervisor</label>
                        </div>
                        <div class="row  ms-1 " *ngFor="let list of superVisorList">
                            <label class="font-header">{{list?.name}},{{list?.phone}}</label>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-3 col-xs-4" style="border-right:3px solid grey ">
                        <div class="row ms-1  me-1" style="border-bottom:1px solid grey">
                            <label class="headerInfo-label">Clients</label>
                        </div>
                        <div class="row  ms-1" *ngFor="let clientRel of clientName">
                            <label class="font-header">{{clientRel}}</label>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-3 col-xs-4" style="border-right:3px solid grey">
                        <div class="row ms-1  me-1" style="border-bottom:1px solid grey">
                            <label class="headerInfo-label">Emergency Contact</label>
                        </div>
                        <div class="row  ms-1  me-1" *ngFor="let EmergencyCon of EmergencyContactList">
                            <label
                                class="font-header">{{EmergencyCon?.name}}({{EmergencyCon?.relationship}}),{{EmergencyCon?.phoneNumber}}</label>
                        </div>


                    </div>
                    <div class="col-lg-2 col-md-3 col-xs-4">
                        <div class="row ms-1" style="border-bottom:1px solid grey">
                            <label class="headerInfo-label">Responsible Party</label>
                        </div>
                        <div class="row  ms-1 me-1" *ngFor="let ResponsibleParty of ResponsiblePartyList">
                            <label
                                class="font-header">{{ResponsibleParty?.name}}({{ResponsibleParty?.relationship}}),{{ResponsibleParty?.phoneNumber}}</label>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>



<div class="row mb-2">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body  p-0">
                <!-- Tabs -->
                <section id="tabs" class="project-tab">
                    <div>
                        <div class="row">
                            <div class="col-md-12">
                                <nav *ngIf="!global.employeetoAgreementEmit" class="mt-2">
                                    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                        <a class="nav-item nav-link " id="nav-notes-tab" data-bs-toggle="tab"
                                            href="#nav-notes" role="tab" aria-controls="nav-notes" aria-selected="true"
                                            (click)="tabchange('notes')" [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000' ,
                                             'mytab-inactive':activeTab!='notes','active':activeTab=='notes'}">Notes
                                        </a>
                                        <a class="nav-item nav-link active " id="nav-GeneralInfo-tab"
                                            data-bs-toggle="tab" href="#nav-GeneralInfo" role="tab"
                                            aria-controls="nav-GeneralInfo" aria-selected="true"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='general','active':activeTab=='general'}"
                                            (click)="tabchange('general')">General
                                        </a>

                                        <a class="nav-item nav-link" id="nav-payorRequiredIds-tab" data-bs-toggle="tab"
                                            *ngIf="fp.payorreqiredidsview" href="#nav-payorRequiredIds" role="tab"
                                            aria-controls="nav-payorRequiredIds"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='payor','active':activeTab=='payor'}"
                                            (click)="tabchange('payor');isEnabledcontact=true;"
                                            aria-selected="false">Payor Required IDs
                                        </a>
                                        <a class="nav-item nav-link" id="nav-payRate-tab" data-bs-toggle="tab"
                                            href="#nav-payRate" role="tab" aria-controls="nav-profile"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='payrate','active':activeTab=='payrate'}"
                                            aria-selected="false" (click)="tabchange('payrate')">Pay
                                            Rates
                                        </a>


                                        <a class="nav-item nav-link " id="nav-PayRollInformation-tab"
                                            data-bs-toggle="tab" href="#nav-PayRollInformation" role="tab"
                                            aria-controls="nav-PayrollInformation" aria-selected="true"
                                            (click)="tabchange('payrollinformation')"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000' ,
                                             'mytab-inactive':activeTab!='payrollinformation','active':activeTab=='payrollinformation'}">Payroll Information
                                        </a>


                                        <a class="nav-item nav-link" id="nav-ContactInfo-tab" data-bs-toggle="tab"
                                            href="#nav-ContactInfo" role="tab" aria-controls="nav-ContactInfo"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='contact','active':activeTab=='contact'}"
                                            (click)="tabchange('contact');isEnabledcontact=true;"
                                            aria-selected="false">Contact
                                        </a>
                                        <a class="nav-item nav-link" id="nav-RelationshipInfo-tab" data-bs-toggle="tab"
                                            href="#nav-RelationshipInfo" role="tab" aria-controls="nav-RelationshipInfo"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='Relationship','active':activeTab=='Relationship'}"
                                            (click)="tabchange('Relationship');isEnabledRelationship=true"
                                            aria-selected="false">Relationship
                                        </a>
                                        <a class="nav-item nav-link" id="nav-DocumentInfo-tab" data-bs-toggle="tab"
                                            href="#nav-DocumentInfo" role="tab" aria-controls="nav-DocumentInfo"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='document','active':activeTab=='document'}"
                                            (click)="tabchange('document');goToAgreement()"
                                            aria-selected="false">Document
                                        </a>
                                        <a class="nav-item nav-link" id="nav-DynamicEmployeeInfo-tab" data-bs-toggle="tab"
                                        href="#nav-DynamicEmployeeInfo"
                                        role="tab" aria-controls="nav-DynamicEmployeeInfo"
                                        (click)="tabchange('dynamicEmployeeInfo');" aria-selected="false"
                                        [ngClass]="{'disabled':Employee.id===0 ,'mytab-inactive':activeTab!='dynamicEmployeeInfo','active':activeTab=='dynamicEmployeeInfo'}">Dynamic
                                       Onboard Employee Form</a>
                                    
                                        <a class="nav-item nav-link " id="nav-EmpwagesInfo-tab" data-bs-toggle="tab"
                                            href="#nav-EmpwagesInfo" role="tab" aria-controls="nav-EmpwagesInfo"
                                            aria-selected="true" (click)="tabchange('EmployeewagesInfo')"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000' ,'mytab-inactive':activeTab!='EmployeewagesInfo','active':activeTab=='EmployeewagesInfo'}">Employee Wages                                           
                                        </a>
                                          <!--
                                        <a class="nav-item nav-link" id="nav-payRollInformation-tab" data-bs-toggle="tab"
                                            href="#nav-payRollInformation" role="tab"
                                            aria-controls="nav-payRollInformation" (click)="GetPayRollDetail()"
                                            (click)="tabchange('payroll')" aria-selected="false"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000' ,'mytab-inactive':activeTab!='payroll','active':activeTab=='payroll'}">
                                            Payroll Information
                                        </a>
                                        <a class="nav-item nav-link " id="nav-workHistory-tab" data-bs-toggle="tab"
                                            href="#nav-workHistory" role="tab" aria-controls="nav-workHistory"
                                            (click)="tabchange('work')" aria-selected="false" (click)="getworkhistry()"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000' ,'mytab-inactive':activeTab!='work','active':activeTab=='work'}">Work
                                            History
                                        </a>
                                        <a class="nav-item nav-link" id="nav-postEmployment-tab" data-bs-toggle="tab"
                                            href="#nav-postEmployment" role="tab" aria-controls="nav-postEmployment"
                                            (click)="tabchange('post')" aria-selected="false"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000' ,'mytab-inactive':activeTab!='post','active':activeTab=='post'}">Post
                                            Employment
                                            Info</a>

                                        <a class="nav-item nav-link" id="nav-OnboardChecklistInfo-tab" data-bs-toggle="tab"
                                            href="#nav-OnboardChecklistInfo" role="tab"
                                            aria-controls="nav-OnboardChecklistInfo"
                                            (click)="tabchange('OnboardChecklist')" aria-selected="false"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000' ,'mytab-inactive':activeTab!='OnboardChecklist','active':activeTab=='OnboardChecklist'}">OnboardChecklist
                                        </a> -->
                                    </div>

                                </nav>
                                <div class="tab-content" id="nav-tabContent">
                                    <!-- GeneralInfo -->
                                    <div class="tab-pane   " id="nav-GeneralInfo" role="tabpanel"
                                        aria-labelledby="nav-GeneralInfo-tab"
                                        [ngClass]="{'active':activeTab=='general','show':activeTab=='general'}">

                                        <div class="row mb-2 p-0 mt-3">
                                            <div class="col ">

                                                <div widget class="card border-0 box-shadow">
                                                    <div class="card-header transparent text-muted">
                                                        <!-- General Info -->
                                                        <div class="row">
                                                            <div class="col-lg-6">
                                                                <h6 class="mb-0 info-header">General Info</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body widget-body pt-2">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div class="row" [formGroup]="EmployeeDataForm">
                                                                    <!-- firstName -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label padding0 col-lg-5">First
                                                                            Name <sup
                                                                                class="super-script">&nbsp;*</sup></label>
                                                                        <input class=" form-control" type="text"
                                                                            formControlName="firstName"
                                                                            [(ngModel)]="Employee.firstName"
                                                                            (change)="EmployeeChange()" id="fname">
                                                                    </div>
                                                                    <!-- middleName -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label col-lg-5 padding0">Middle
                                                                            Name</label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.middleName"
                                                                            formControlName="middleName"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1" [formGroup]="EmployeeDataForm">
                                                                    <!-- lastName -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label padding0 col-lg-5">Last
                                                                            Name
                                                                            <sup
                                                                                class="super-script">&nbsp;*</sup></label>
                                                                        <input class=" form-control" type="text"
                                                                            formControlName="lastName"
                                                                            [(ngModel)]="Employee.lastName"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                    <!-- (keyup.Tab)="onKey($event,'lastname')" (keydown.Tab)="onKey($event,'gender')" -->
                                                                    <!-- DOB -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label col-lg-5 padding0">DOB<sup
                                                                                class="super-script">&nbsp;*</sup></label>

                                                                        <my-date-picker [options]="myDatePickerOptions"
                                                                            style="width: 300%;"
                                                                            formControlName="dateofBirth"
                                                                            [selDate]="Employee.dOB"
                                                                            placeholder="mm/dd/yyyy"
                                                                            (dateChanged)="onDateChanged($event)"
                                                                            (inputFieldChanged)="DOBdatechange($event,'dob')">
                                                                        </my-date-picker>

                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <!-- Gender -->
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <label
                                                                            class="label padding0 col-lg-5">Gender<sup
                                                                                class="super-script">&nbsp;*</sup></label>
                                                                        <select class=" form-control"
                                                                            formControlName="genderLid"
                                                                            [(ngModel)]="Employee.genderLid"
                                                                            (change)="EmployeeChange()">
                                                                            <option *ngFor="let val of GenderList"
                                                                                [value]="val.id">
                                                                                {{val.lovName}}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                    <!-- age -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label col-lg-5 padding0">Age</label>
                                                                        <input class=" form-control" type="text"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            disabled [(ngModel)]="Employee.age"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                </div>
                                                                <div class="row mt-1">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <!-- Type -->
                                                                        <label
                                                                            class="label padding0 col-lg-5">Type</label>
                                                                        <ng-select class="w-100"
                                                                            formControlName="employeeTypeLids"
                                                                            [searchable]="true" [clearable]="true"
                                                                            [items]="EmployeeTypeItems"
                                                                            [(ngModel)]="Employee.employeeTypeLid"
                                                                            bindLabel="lovName" bindValue="id"
                                                                            (change)="EmployeeChange()">
                                                                        </ng-select>
                                                                    </div>
                                                                    <!-- AKA -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label col-lg-5 padding0">AKA</label>
                                                                        <input class="form-control" type="text"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            [(ngModel)]="Employee.aKA"
                                                                            [disabled]="global.viewTabs"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                </div>
                                                                <div class="row mt-1">
                                                                    <!-- rNNPI -->
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <label class="label padding0 col-lg-5">RN
                                                                            NPI</label>

                                                                        <input class="form-control" type="text"
                                                                            formControlName="rNNPI"
                                                                            [(ngModel)]="Employee.rNNPI"
                                                                            (change)="EmployeeChange()" minlength=10
                                                                            maxlength=10>

                                                                    </div>



                                                                    <!-- maritalStatusLid -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label col-lg-6 padding0">Marital
                                                                            Status</label>
                                                                        <ng-container
                                                                            *ngFor=" let val of WithHoldingList">
                                                                            <input type="radio" [value]="val.id"
                                                                                [ngModelOptions]="{standalone: true}"
                                                                                (change)="EmployeeChange()"
                                                                                [disabled]="global.viewTabs"
                                                                                [(ngModel)]="Employee.maritalStatusLid" />
                                                                            <span class="mt-1 ms-2 me-3"
                                                                                style="font-size:13px;">{{val.lovName}}</span>
                                                                        </ng-container>
                                                                    </div>

                                                                </div>
                                                                <div class="row mt-1">
                                                                    <div class="col-lg-7" style="text-align: center;">
                                                                        <span class="err"
                                                                            *ngIf="EmployeeDataForm.controls['rNNPI'].invalid">

                                                                            <p>Enter Valid RN NPI Number</p>
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1" [formGroup]="EmployeeDataForm">
                                                                    <!-- UMPI -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label padding0 col-lg-5">UMPI</label>
                                                                        <input class="form-control" type="text"
                                                                            formControlName="uMPI"
                                                                            [(ngModel)]="Employee.uMPI"
                                                                            (change)="EmployeeChange()" minlength=10
                                                                            maxlength=10>

                                                                    </div>

                                                                    <!-- pCACertificateNumber -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label col-lg-5 padding0">PCA
                                                                            Certificate Number</label>
                                                                        <input class="form-control" type="text"
                                                                            [(ngModel)]="Employee.pCACertificateNumber"
                                                                            formControlName="pCACertificateNumber"
                                                                            (keypress)="isalphanumbericonly($event)">

                                                                    </div>
                                                                    <!-- <span class="help-block text-danger col-6 offset-3"
                                                                        *ngIf="!EmployeeDataForm.get('uMPI').valid && EmployeeDataForm.get('uMPI').touched">
                                                                       
                                                                    </span> -->


                                                                </div>
                                                                <div class="row mt-1">
                                                                    <div class="col-lg-7" style="text-align: center;">
                                                                        <span class="err"
                                                                            *ngIf="EmployeeDataForm.controls['uMPI'].invalid">

                                                                            <p>Enter Valid UMPI Number</p>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <!-- *ngIf="this.global.agencyCode=='SUPERADMIN'" -->
                                                                <!-- PEmployeeId -->
                                                                <div class="row mt-1 mb-2">
                                                                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <label
                                                                            class="label col-lg-5 padding0">PEmployeeId</label>
                                                                        <input class="form-control" type="number" maxlength="9"
                                                                            [(ngModel)]="Employee.pEmployeeId"
                                                                            formControlName="pEmployeeId">
                                                                    </div> -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 mt-2 col-xs-12 aligned_form">
                                                                        <label class="label col-lg-5 padding0">Office
                                                                            Staff</label>
                                                                        <input type="checkbox" style="zoom: 1.2"
                                                                            class="me-5"
                                                                            [(ngModel)]="Employee.officeStaff"
                                                                            [disabled]="global.viewTabs"
                                                                            [ngModelOptions]="{standalone: true}">

                                                                        <button type="button"
                                                                            [disabled]="global.viewTabs"
                                                                            class="btn btn-sm ms-lg-5"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#SSNModel"
                                                                            [style.backgroundColor]="Employee.sSN? 'green': 'red'">SSN</button>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <div class="row">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label col-lg-3 ">Street</label>
                                                                            <button type="button"
    
                                                                            [disabled]="global.viewTabs"
        
                                                                                class="btn blue-btn btn-sm mb-2 me-4 mb-2"        
                                                                                data-bs-target="#SearchAddress" data-bs-toggle="modal"        
                                                                                (click)="AddressGoogleMap = true">
        
                                                                                Address
        
                                                                            </button>
                                                                        <input class="ms-4 form-control" type="text"
                                                                            [(ngModel)]="Employee.street"
                                                                            [disabled]="global.viewTabs"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (change)="EmployeeChange()">
                                                                    </div>

                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">


                                                                        <label class="label padding0 col-lg-5">Languages

                                                                        </label>
                                                                        <ng-select class="w-100"
                                                                            formControlName="languageLid"
                                                                            [multiple]="true"
                                                                            [(ngModel)]="Employee.languageLid"
                                                                            [searchable]="true"
                                                                            [disabled]="global.viewTabs"
                                                                            [clearable]="true" [items]="LanguageList"
                                                                            bindLabel="lovName" bindValue="id">
                                                                        </ng-select>
                                                                    </div>

                                                                </div>
                                                                <div class="row mt-1">
                                                                    <!-- <div
                                                                    class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                    <label
                                                                        class="label col-lg-5 padding0">Driver License</label>
                                                                    <input class=" form-control" type="text"
                                                                      
                                                                        [disabled]="global.viewTabs"
                                                                        (change)="EmployeeChange()">
                                                                           [(ngModel)]="Employee.driverLicense" 
                                                                </div> -->
                                                                    <!-- <div
                                                                    class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">

                                                                    <label
                                                                        class="label  col-lg-5  padding0">Place of Birth</label>
                                                                    <input class=" form-control" type="text"
                                                                       (change)="EmployeeChange()">
                                                                       <!-- [(ngModel)]="Employee.placeofBirth"  
                                                                    
                                                                </div> -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label col-lg-5 padding0">APT</label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.apt"
                                                                            [disabled]="global.viewTabs"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                    <div [formGroup]="EmployeeDataForm"
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">

                                                                        <label
                                                                            class="label  col-lg-5  padding0">Email<sup
                                                                                class="super-script">&nbsp;*</sup></label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.email"
                                                                            formControlName="email" required
                                                                            (change)="EmployeeChange()">

                                                                    </div>


                                                                </div>
                                                                <div class="row mt-1">
                                                                    <div class="col-lg-6">

                                                                    </div>
                                                                    <div class="col-lg-6" style="text-align: center;">
                                                                        <span class="err"
                                                                            *ngIf="EmployeeDataForm.controls['email'].touched && EmployeeDataForm.controls['email'].invalid">
                                                                            <p>*Enter Valid Mail</p>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="row mt-1" [formGroup]="EmployeeDataForm">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5 padding0">Phone1</label>
                                                                        <input class=" form-control" type="text"
                                                                            formControlName="phone1"
                                                                            [(ngModel)]="Employee.phone1"
                                                                            (keypress)="keyPress($event)"
                                                                            (ngModelChange)="DemographicPhoneFormat();EmployeeChange"
                                                                            minlength="14" maxlength="14">
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <label
                                                                            class="label  col-lg-5  padding0">Phone2</label>
                                                                        <input class=" form-control" type="text"
                                                                            formControlName="phone2"
                                                                            [(ngModel)]="Employee.phone2"
                                                                            (keypress)="keyPress($event)"
                                                                            (ngModelChange)="DemographicPhoneFormat();EmployeeChange"
                                                                            minlength="14" maxlength="14">
                                                                    </div>
                                                                </div>
                                                                <div class="row mt-1">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5 padding0">City</label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.city"
                                                                            [disabled]="global.viewTabs"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5  padding0">State</label>
                                                                        <ng-select [items]="stateList" class="w-100"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            [(ngModel)]="Employee.steet"
                                                                            [disabled]="global.viewTabs"
                                                                            [selectOnTab]="true" [searchable]="true"
                                                                            [clearable]="true" bindLabel="name"
                                                                            bindValue="abbreviation">
                                                                        </ng-select>
                                                                    </div>
                                                                </div>
                                                                <div class="row mt-1">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5 padding0">County</label>
                                                                        <input class=" form-control" type="text"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            [(ngModel)]="Employee.county"
                                                                            [disabled]="global.viewTabs"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <label class="label  col-lg-5  padding0">Zip
                                                                            code</label>

                                                                        <input class=" form-control me-1"
                                                                            (keypress)="keyPress($event)"
                                                                            [(ngModel)]="Employee.zipcode" type="text"
                                                                            minlength="5" maxlength="10"
                                                                            formControlName="zipcode"
                                                                            (change)="EmployeeChange()">

                                                                        <!-- [disabled]="Employee.street==null||
                                                                                Employee.street==undefined|| Employee.street==''||Employee.city==null||Employee.city==undefined
                                                                                ||Employee.city==''||Employee.steet==null||Employee.steet==undefined||Employee.steet==''" -->
                                                                        <!-- <button type="button" class="zipbtn col-lg-2"
                                                                            (click)="getZip()">Get Zip</button> -->
                                                                    </div>
                                                                </div>
                                                                <!-- ............................................................. -->
                                                                <div class="row mt-1">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label  col-lg-5 padding0">Driver
                                                                            License</label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.driverLicense"
                                                                            [disabled]="global.viewTabs"
                                                                            (ngModelChange)="EmployeeChange()">
                                                                    </div>

                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label  col-lg-5  padding0">Place
                                                                            Of Birth</label>

                                                                        <input class=" form-control me-1"
                                                                            [(ngModel)]="Employee.placeofBirth"
                                                                            [disabled]="global.viewTabs" type="text"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                </div>
                                                                <div class="row mt-1"
                                                                    *ngIf="Employee.driverLicense !=null && Employee.driverLicense != undefined && Employee.driverLicense!=''">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label  col-lg-5 padding0">Driver
                                                                            License Expiry Date
                                                                            <sup class="super-script">&nbsp;*</sup>
                                                                        </label>
                                                                        <my-date-picker
                                                                            [options]="myDatePickerOptionsLicense"
                                                                            style="width: 300%;"
                                                                            formControlName="dateofBirth"
                                                                            [selDate]="Employee.driverLicenseExpirydate"
                                                                            placeholder="mm/dd/yyyy"
                                                                            (inputFieldChanged)="DateFormat($event,'inputchanged','LicenseExpiryDate')"
                                                                            (dateChanged)="DateFormat($event,'datechanged','LicenseExpiryDate')">
                                                                        </my-date-picker>
                                                                    </div>
                                                                </div>









                                                                <!-- <div class="row mt-1">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5 padding0">Driver License</label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.driverlicense"
                                                                            [disabled]="global.viewTabs"
                                                                        >
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                       >
                                                                        <label class="label  col-lg-5  padding0">Place Of Birth
                                                                            </label>

                                                                        <input class=" form-control me-1"
                                                                        [disabled]="global.viewTabs"
                                                                            [(ngModel)]="Employee.placeofbirth" type="text"
                                                                           
                                                                            >

                                                                       
                                                                    </div>
                                                                </div> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="row ps-4 mb-3">
                                                        <div class="col-lg-8">
                                                            <h6 class="info-header">Login Info</h6>
                                                            <hr style="margin-top: 0rem" />
                                                            <div class="row">
                                                                <div class="col-lg-5">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label
                                                                                class="font-weight-bold  me-3 ps-4">User
                                                                                Name
                                                                                <sup class="super-script"
                                                                                    *ngIf="Employee.requiredEVV">&nbsp;*</sup></label>
                                                                        </div>
                                                                        <div class="col-lg-6"
                                                                            [formGroup]="EmployeeDataForm">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="Employee.username"
                                                                                name="username"
                                                                                formControlName="username"
                                                                                [disabled]="!Employee.requiredEVV"
                                                                                autocomplete="off">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-5"
                                                                    *ngIf="Employee.loginUserId==null">
                                                                    <div class="row ">
                                                                        <div class="col-lg-6">
                                                                            <label class="font-weight-bold ">Password
                                                                                <sup class="super-script"
                                                                                    *ngIf="Employee.requiredEVV">&nbsp;*</sup></label>
                                                                        </div>
                                                                        <div class="col-lg-6"
                                                                            [formGroup]="EmployeeDataForm">
                                                                            <input type="password" class="form-control"
                                                                                [(ngModel)]="Employee.password"
                                                                                name="Password"
                                                                                formControlName="password"
                                                                                (keyup)="passvalid($event)"
                                                                                [disabled]="!Employee.requiredEVV"
                                                                                autocomplete="off">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-2"
                                                                    *ngIf="Employee.loginUserId!=null&&Employee.id!='00000000-0000-0000-0000-000000000000'">
                                                                    <button class="btn  btn-sm" type="button"
                                                                        data-target="#Reset_Confirmation"
                                                                        data-toggle="modal"
                                                                        [disabled]="!Employee.requiredEVV||global.viewTabs">
                                                                        Reset Password</button>
                                                                </div>
                                                                <div class="col-lg-2 d-flex">
                                                                    <label class="toggle-control">
                                                                        <input type="checkbox"
                                                                            [(ngModel)]="Employee.requiredEVV"
                                                                            [disabled]="global.viewTabs"
                                                                            (change)="switchchange()"
                                                                            [ngModelOptions]="{standalone: true}">
                                                                        <span class="control "></span>
                                                                    </label>
                                                                    <div class="evvfont">
                                                                        <div class="col-lg-0 mt-1 ms-2">
                                                                            <label
                                                                                style="color:black;background-color: rgb(243, 243, 31);">Evv</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <h6 class="info-header">EVV Manual Timesheet</h6>
                                                            <hr style="margin-top: 0rem" />
                                                            <ejs-switch
                                                            [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || !Employee.requiredEVV"
                                                            (change)="switchchangeETimesheet($event)" cssClass="bar-color"
                                                            [checked]="Employee.isEligibleForManualETimeSheet">
                                                        </ejs-switch>
                                                        </div>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="row ps-4">
                                            <label class="ms-1 notealert"><i>Note:&nbsp;Password should
                                                    contain atleast 8 characters/
                                                    digits includes 1 special character, 1 lower and
                                                    uppercase characters
                                                </i></label>
                                        </div> -->
                                        <div class="row ms-1 mt-3 mb-2">
                                            <div class="col">
                                                <!-- <button class="btn btn-sm   ms-1 " type="button" data-bs-toggle="modal"
                                                    data-bs-target="#keystatusmodal" [disabled]="global.viewTabs">Key
                                                    Status/Dates</button>
                                                &nbsp; &nbsp; -->

                                                <!-- <button class="btn btn-sm  " (click)="ClearingNotes()"
                                                    [disabled]="!isShowFields || disablePortalBtn"
                                                    data-bs-target="#sendToEmployee" data-bs-toggle="modal">
                                                    Create Employee Account </button> -->

                                                <button type="button " [disabled]="!isShowFields || disablePortalBtn"
                                                    class="btn blue-btn btn-sm ml-2"
                                                    (click)="employeevv = !employeevv;ClearingNotes()">Employee
                                                    EVV & Portal</button>
                                                <!-- &nbsp; &nbsp; -->
                                                <!-- <button class="btn btn-sm  " [disabled]="isEnable|| global.viewTabs "
                                                    (click)="DisablePortal()">Disable Employee Portal
                                                </button> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-12" [hidden]="!employeevv">
                                            <div *ngIf="employeevv">
                                                <div class="card-body widget-body pt-1">
                                                    <div class="row align-item-center pt-1 ms-1">
                                                        <div style="display: contents;">
                                                            <h5 class="mb-0 font-header pt-2">Enable Employee EVV &
                                                                Portal</h5>
                                                        </div>
                                                        <div class="col-lg-1 ">
                                                            <label class="toggle-control">
                                                                <input type="checkbox"
                                                                    [(ngModel)]="Employee.requiredEVV"
                                                                    (change)="switchchange()"
                                                                    [disabled]="disablePortalBtn || global.clientId==0"
                                                                    [ngModelOptions]="{standalone: true}">
                                                                <span class="control"></span>
                                                            </label>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 d-inline-flex pt-1">
                                                            <label class="mr-1 label-bold w-150">User Name
                                                                <sup class="super-script"
                                                                    *ngIf="Employee.requiredEVV">&nbsp;*</sup>
                                                            </label>
                                                            <input type="text" class="form-control w-50" name="userName"
                                                                [(ngModel)]="Employee.username"
                                                                [ngModelOptions]="{standalone: true}" disabled />
                                                        </div>
                                                        <div class="col-lg-5">
                                                            <div class="row">
                                                                <div class="col-lg-6 mt-1">
                                                                    <h5 class="mb-0 font-header">Enable E-Manual
                                                                        Timesheet</h5>
                                                                </div>
                                                                <div class="col-lg-6">
                                                                    <label class="toggle-control">
                                                                        <input type="checkbox"
                                                                            [(ngModel)]="Employee.isEligibleForManualETimeSheet"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            [disabled]="disablePortalBtn">
                                                                        <span class="control "></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>

                                        </div>

                                        <!-- </div> -->

                                    </div>

                                    <div class="tab-pane   " id="nav-payorRequiredIds" role="tabpanel"
                                        aria-labelledby="nav-payorRequiredIds-tab"
                                        [ngClass]="{'active':activeTab=='payor','show':activeTab=='payor'}">
                                        <app-payor-required-ids-list
                                            *ngIf="isPayorRequiredEdit==false&&Employee.id!='00000000-0000-0000-0000-000000000000'"
                                            (IsViewEditpayorequired)="dataEmitfromChild($event)"
                                            [employeeId]="Employee.id"></app-payor-required-ids-list>
                                    </div>

                                    <!-- NOTES...................... -->


                                    <div class="tab-pane fade" id="nav-notes" role="tabpanel"
                                        aria-labelledby="nav-notes-tab"
                                        [ngClass]="{'active':activeTab=='notes','show':activeTab=='notes'}">


                                    </div>


                                    <!--..........PAYROLL...................  -->



                                    <div class="tab-pane " id="nav-PayrollInformation" role="tabpanel"
                                        aria-labelledby="nav-PayrollInformation-tab"
                                        [ngClass]="{'active':activeTab=='payrollinformation','show':activeTab=='payrollinformation'}">

                                        <app-employee-payroll *ngIf="ispayrollinformation" [EmployeeId]="Employee.id">
                                        </app-employee-payroll>

                                    </div>


                                    <!-- payRate -->
                                    <div class="tab-pane " id="nav-payRate" role="tabpanel"
                                        aria-labelledby="nav-payRate-tab"
                                        [ngClass]="{'active':activeTab=='payrate','show':activeTab=='payrate'}">

                                        <app-pay-rates-list *ngIf="isPayRateEdit==false"
                                            (IsViewEditpayrate)="dataEmitfromPayrate($event)"
                                            [payratevalueChange]="Employee.id"></app-pay-rates-list>
                                    </div>
                                    <!-- ContactInfo -->
                                    <div class="tab-pane " id="nav-ContactInfo" role="tabpanel"
                                        aria-labelledby="nav-ContactInfo-tab"
                                        [ngClass]="{'active':activeTab=='contact','show':activeTab=='contact'}">
                                        <div class="row mt-3 mr-0 ">

                                        </div>
                                    </div>
                                    <!-- RelationshipInfo -->
                                    <div class="tab-pane   " id="nav-RelationshipInfo" role="tabpanel"
                                        aria-labelledby="nav-RelationshipInfo-tab"
                                        [ngClass]="{'active':activeTab=='Relationship','show':activeTab=='Relationship'}">

                                    </div>
                                    <!-- DocumentInfo -->
                                    <div class="tab-pane" id="nav-DocumentInfo" role="tabpanel"
                                        aria-labelledby="nav-DocumentInfo-tab"
                                        [ngClass]="{'active':activeTab=='document','show':activeTab=='document'}">
                                        <div class="col-12 p-0">
                                            <app-employee-agreementlist *ngIf="OnboardListemitBo.employeeToDocument"
                                                [agreementemitBo]="OnboardListemitBo"
                                                (dataEmitFromemployee)="dataEmitFromOnboard($event)">
                                            </app-employee-agreementlist>
                                        </div>
                                    </div>
                                    <!---OnboarddINfo-->
                                    <div class="tab-pane" id="nav-DynamicEmployeeInfo" role="tabpanel"
                                        aria-labelledby="nav-DynamicEmployeeInfo-tab"
                                        [ngClass]="{'active':activeTab=='dynamicEmployeeInfo','show':activeTab=='dynamicEmployeeInfo'}">

                                     <div class="row mt-3 text-right">
                                        <div class="col-lg-10">
                                        </div>
                                        <div class="col-lg-2">

                                            </div>
                                        </div>
                                    </div> 
                                  

                                </div>
                                  <!---Employee Wages Info-->
                                  <div class="tab-pane" id="nav-EmpwagesInfo" role="tabpanel"
                                  aria-labelledby="nav-EmpwagesInfo-tab"
                                  [ngClass]="{'active':activeTab=='EmployeewagesInfo','show':activeTab=='EmployeewagesInfo'}">

                                 

                              </div>
                                </div>
                                <app-client-employee-contact [ContactRelation]="ClientEmployeeContact"
                                    *ngIf="isRelationcontact">
                                </app-client-employee-contact>

                                <app-client-employee-relationship [CERelation]="ClientEmployeeRelationship"
                                    *ngIf="isRelationShip">
                                </app-client-employee-relationship>

                                <app-employee-notes *ngIf="isNotes" [Employee]="Employee">
                                </app-employee-notes>


                                <app-client-employee-dynamicform [DynamicFormRelation]="ClientEmployeeDynamicForm"
                                    *ngIf="isdynamicFormEmployee">
                                </app-client-employee-dynamicform>

                            <app-employee-wages *ngIf="employeewages"
                            (IsViewEditpayrate)="dataEmitfromPayrate($event)"
                            [EmployeeId]="Employee.id"
                            ></app-employee-wages>


                            </div>
                        </div>
                   
                </section>
            </div>
        </div>
    </div>
</div>
<span id="closessnModal" data-bs-target="#SSNModel" data-bs-toggle="modal"></span>
<div class="modal fade " id="SSNModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Social Security Number</h5>
                <button type="button" class="btn-close" (click)="closeSsnValidation()" [disabled]="ssnerr"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-2">
                        <label class="label-bold">SSN&nbsp;:</label>
                    </div>
                    <div class="col-lg-10">
                        <input type=" text" [(ngModel)]="Employee.sSN" class="form-control"
                            (keypress)="keyPress($event)" minlength=9 maxlength=9 (ngModelChange)="EmployeeChangeSSN()">
                    </div>

                </div>
                <div class="col offset-2 mt-1">
                    <span class="col-8 offset-2 help-block text-danger " *ngIf="ssnerr">
                        <p>Enter Valid SSN Number</p>
                    </span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="ssnerr"
                    (click)="closeSsnValidation()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="sendToEmploye" data-bs-toggle="modal" data-bs-target="#sendToEmployee"></span>
<div class="modal fade" id="sendToEmployee" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Mail Notes</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <p>Email :<b>{{Employee.email}}</b></p>
                <label>UserName<sup class="super-script">*</sup></label>
                <input class="form-control" [(ngModel)]="portalBo.username">
                <label class="mx-auto mt-3" style="font-size: 12px; color: red;"><i
                        class="fa fa-info-circle fa-lg"></i>&nbsp;
                    This will be attached above in this mail</label>

                <textarea class="form-control" [(ngModel)]="portalBo.agencyNote"> </textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn  btn-sm"
                    [disabled]="portalBo.username==null||portalBo.username==undefined|| portalBo.username==''"
                    (click)="SentToEmployeePortal()">Submit</button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<span id="openEvvModal" data-bs-target="#EnableEvv" data-bs-toggle="modal">
</span>
<div class="modal fade" id="EnableEvv" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="font-header">
                    Disable EVV</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"
                    (click)="Employee.requiredEVV=!Employee.requiredEVV"></button>
            </div>
            <div class="modal-body">
                <label *ngIf="!Employee.requiredEVV "> This will log out all the sessions for this user!</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm" (click)="passwordResetFunction()">Continue</button>
                <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal"
                    (click)="Employee.requiredEVV=!Employee.requiredEVV">No</button>
            </div>
        </div>
    </div>
</div>


<!-- AddressGoogleMap -->
<span id="openSearchAddressModal" data-bs-target="#SearchAddress" data-bs-toggle="modal">
</span>
<div class="modal fade" id="SearchAddress" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="font-header">
                    Search Address</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"
                    (click)="AddressGoogleMap=false;">&times;</button>
            </div>
            <div class="modal-body" style="min-height: 100px;">
                <div class="row">
                    <div class="col-lg-12">
                      <app-google-map *ngIf="AddressGoogleMap==true" (GoogleMapEmit)="EmitGoogleMapComponent($event)"></app-google-map>
                    </div>
                  </div>
            </div>
            <div class="modal-footer">
                <button type="button"class="btn btn-primary btn-sm" data-bs-dismiss="modal"
                    (click)="AddressGoogleMap=false">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!---------------------------payor required Id edit -------------------------------------------------------------->
<app-payor-required-ids-edit *ngIf="isPayorRequiredEdit==true&&editEmployeeId!='00000000-0000-0000-0000-000000000000'"
    (IsViewEditpayorequired)="dataEmitfromChild($event)" [payoRequiredViewEditdata]="payoRequiredViewEdit">
</app-payor-required-ids-edit>

<app-pay-rates-edit *ngIf="isPayRateEdit==true&&editEmployeeId!='00000000-0000-0000-0000-000000000000'"
    (IsViewEditpayrate)="dataEmitfromPayrate($event)" [payrateevntchange]="payrateview">

</app-pay-rates-edit>